import React, { useEffect, useState } from 'react';
import PageSaleDrLicita from 'components/atoms/page_sale_dr_licita';
import { ProportionalSale } from 'services/actions/proportional_sale';

const SaleDrLicita: React.FC = () => {
  const [dados, setDados] = useState<object | null>(null);

  useEffect(() => {
    (async () => {
      const request = await ProportionalSale(10, [16]);
      request?.status === 200 && setDados(request?.data);
    })();
    document.title = 'Dr Licita - ConLicitação';
  }, []);

  return (
    <div className="page-container">
      <PageSaleDrLicita dados={dados} />
    </div>
  );
};
export { SaleDrLicita };
